<template>
    <div id="images-catalog" v-if="currentImage">
        <img
            v-if="!isCurrentImageVideo"
            class="mx-md-auto ml-lg-auto d-block img-fluid design-your-own-img"
            itemprop="image"
            :alt="getAlt"
            :src="currentImage.src" />
        <video v-if="isCurrentImageVideo" autoplay loop muted playsinline class="mx-md-auto ml-lg-auto d-block img-fluid design-your-own-img" :alt="getAlt">
            <source :src="addMp4Ext" type="video/mp4" />
        </video>
        <siema class="siema-carousel" auto-play :ready="true" :options="options">
            <div v-for="m in mediaThumbnails" :key="m.src" class="slide">
                <img
                    v-if="m.type !== 'video'"
                    itemprop="image"
                    :class="{ 'current-src': m.src === currentImage.src }"
                    class="thumbnail-img d-block my-3 mx-2"
                    :alt="getAlt"
                    :src="m.src"
                    @click="switchImg(m)" />
                <div v-if="m.type === 'video'" class="position-relative video-thumbnails-area" @click="switchImg(m)">
                    <video muted :class="{ 'current-src': m.src === currentImage.src }" class="thumbnail-img d-block my-3 mx-2" :alt="getAlt">
                        <source :src="m.src" type="video/mp4" />
                    </video>
                    <img v-if="m.type === 'video'" class="video-sign" src="../../../assets/images/icons/video.svg" :alt="getAlt" />
                </div>
            </div>
        </siema>
    </div>
</template>

<script>
export default {
    name: "images-catalog",
    props: ["Media", "alt", "isDiamond"],
    data() {
        return {
            currentImage: null,
            options: {
                duration: 200,
                easing: "ease-out",
                perPage: 3,
                startIndex: 0,
                draggable: true,
                multipleDrag: true,
                threshold: 20,
                loop: true,
            },
        };
    },
    computed: {
        getVideo() {
            return this.Media && this.Media.length ? this.Media.find((m) => m.type === "video") : null;
        },
        getCertificate() {
            return this.Media && this.Media.length ? this.Media.find((m) => m.type === "certificate") : null;
        },
        getPictures() {
            return this.Media && this.Media.length ? this.Media.filter((m) => m.type === "picture") : null;
        },
        mediaThumbnails() {
            let arraysToCheck;
            if (this.isDiamond) {
                arraysToCheck = [this.getVideo, ...this.getPictures.slice(0, 3), this.getCertificate];
            } else {
                arraysToCheck = [this.getVideo, ...this.getPictures];
            }
            return arraysToCheck.filter((arrTC) => arrTC);
        },
        isCurrentImageVideo() {
            return this.currentImage ? this.currentImage.type === "video" : false;
        },
        isCurrentImageCertificate() {
            return this.currentImage ? this.currentImage.type === "certificate" : false;
        },
        getAlt() {
            return this.alt ? this.alt : "Diamond";
        },
        addMp4Ext() {
            if (!this.currentImage.src.includes(".mp4")) return this.currentImage.src + ".mp4";
            else return this.currentImage.src;
        },
    },
    methods: {
        switchImg(current) {
            this.currentImage = current;
        },
    },
    mounted() {
        this.currentImage = this.getVideo ? this.getVideo : this.Media.find((m) => m.type === "picture").src;
    },
};
</script>

<style lang="scss" scoped>
#images-catalog {
    .thumbnail-img {
        width: 90px;
        height: auto;
        cursor: pointer;
    }
    .current-src {
        border: solid 2px #ff4d68;
    }
    video {
        aspect-ratio: 1 / 1;
    }
    .video-sign {
        top: 20px;
        left: 27px;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        position: absolute;
        border: 5px solid #fff;
    }
    .video-thumbnails-area {
        cursor: pointer;
    }
    .slide {
        width: 100px;
    }
    .siema-carousel {
        width: 90%;
        margin: 0 auto;
    }
}
</style>
